module.exports = __webpack_public_path__ + "img/Lauren.ad2c496e.png";